<perfect-scrollbar style="height: calc(100% - 33px);">
    <div fxLayout="column" class="back">
        <mat-sidemenu-item *ngFor="let menu of menus" [menu]="menu" [iconOnly]="iconOnly" [hideOnClick]="hideOnClick"  [class.open]="menu.open">
        </mat-sidemenu-item>
    </div>
</perfect-scrollbar>